import { useState } from "react";
import { Link } from "@shopify/hydrogen/client";
import { NavbarCard } from "@components/molecules/navbar-card/index.server";
import { NavbarMenu } from "@models/types/menu.interface";
import useScrollY from "@models/interactions/use-scrollY";
import { useAtom } from "jotai";
import { showCountdownAtom } from "@models/state/count-down";

export function useNavigation() {
  const [item, setItem] = useState<NavbarMenu | null>(null);

  const selectItem = (selected: NavbarMenu | null) => {
    setItem(selected);
  };

  return {
    model: {
      item,
    },
    operations: {
      selectItem,
    },
  };
}

function SubNavbar({ item, selected }: { item: any, selected: any }) {
  const [showCountdown, _] = useAtom(showCountdownAtom);
  const scrollY = useScrollY();

  const navClassName = [
    "bg-white fixed flex justify-center gap-[35px] w-full left-0 !ml-0 py-[65px] shadow-[0px_3px_6px_#00000029] mb-4",
    selected?.slug === item.slug ? "block" : "hidden",
    scrollY > 80 || !showCountdown ? "top-[100px]" : "lg:top-[180px]",
  ];

  if (item.items.length) {
    return (
      <div className={navClassName.join(" ")}>
        {item.items
          .filter((entry: any) => entry.title !== "")
          .map((entry: any, index: number) => {
            return (
              <Link
                key={`link-${index}`}
                to={entry.url}
                target={entry.target}
              >
                {NavbarCard(entry)}
              </Link>
            );
          })}
      </div>
    );
  }

  return <></>;
};

export default function Navigation({ menu }: { menu: any }) {
  const { model, operations } = useNavigation();

  return (
    <>
      <nav className="hidden h-full lg:flex">
        {(menu || []).map((item: any, index: number) => {
          return (
            <div
              key={`nav-link-${index}`}
              className="h-full px-5"
              onMouseEnter={() => operations.selectItem(item)}
              onMouseLeave={() => operations.selectItem(null)}
            >
              <Link
                to={item.url}
                className="flex items-center h-full font-chivo-regular text-[13px] border-y-[3px] border-white hover:border-b-black"
              >
                {item.title}
              </Link>
              <SubNavbar
                item={item}
                selected={model.item}
              />
            </div>
          );
        })}
      </nav>
    </>
  );
}
